/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */

import React, { forwardRef, memo, useEffect, useMemo } from 'react';

import { Box } from '@mui/material';

import { useThemeMode } from '../../../providers';

import { TranscriptSentenceImportantPhrases } from './TranscriptSentenceImportantPhrases';
import { TranscriptSentenceKeywordsAndImportantPhrases } from './TranscriptSentenceKeywordsAndImportantPhrases';
import { TranscriptSentenceSentimentalAnalysis } from './TranscriptSentenceSentimentalAnalysis';
import { TranscriptSentenceTranscription } from './TranscriptSentenceTranscription';

export const TranscriptSentence = memo(
  forwardRef(
    (
      {
        onSeekTo,
        sentence,
        startTime,
        activeTranscription,
        active,
        index,
        onSetActiveIndex,
        formattedSentence,
      }: {
        formattedSentence: string;
        sentence: any;
        onSeekTo?: (value: number) => void;
        startTime?: string;
        activeTranscription: number;
        index: number;
        onSetActiveIndex: (value: number) => void;
        active: boolean;
      },
      ref,
    ) => {
      const { themeMode } = useThemeMode();

      const borderColor = useMemo(() => {
        if (active) {
          return 'primary.main';
        }
        if (themeMode === 'light') {
          return 'grey.300';
        }

        return 'grey.800';
      }, [active, themeMode]);

      useEffect(() => {
        if (active) {
          onSetActiveIndex(index);
        }
      }, [onSetActiveIndex, active, index]);

      return (
        <Box
          ref={ref}
          onClick={
            onSeekTo
              ? () => {
                  onSetActiveIndex(index);
                  onSeekTo(Number(startTime) / 1000);
                }
              : () => onSetActiveIndex(index)
          }
          sx={{
            backgroundColor: (theme) => (theme.palette.mode === 'light' ? 'grey.100' : 'grey.700'),
            borderRadius: 2,
            border: '1px solid',
            borderColor,
            p: 3,
            mb: 3,
            '&:hover': {
              cursor: onSeekTo ? 'pointer' : 'default',
            },
          }}
        >
          {activeTranscription === 0 && <TranscriptSentenceTranscription sentence={formattedSentence} />}
          {activeTranscription === 1 && <TranscriptSentenceImportantPhrases sentence={sentence} />}
          {activeTranscription === 2 && <TranscriptSentenceSentimentalAnalysis item={sentence} />}
          {activeTranscription === 3 && <TranscriptSentenceKeywordsAndImportantPhrases item={sentence} />}
        </Box>
      );
    },
  ),
);
